<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AOlkvy/text/images/cover.jpg?1684514597004" alt="This image is the cover for the book The Survival of Margaret Thomas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Survival of Margaret Thomas
      </h1>
      <p class="bookDescription body article font2">
        <p>The West of the late 1800s is a lonely place. Margaret Thomas lives that loneliness. Alone, after the shooting death of her sheriff husband that she blames on herself and searches for solace in a liquor bottle. Then one day a miracle arrives in a telegram informing her that the bank robber who shot her husband has been arrested. She is invited to the trial.<br/><br/>But that judicial proceeding is all the way across the wild United States and she’s a former easterner now living in Missouri. Margaret must make this journey for her husband’s sake and,  if she is ever to live again, assuage the guilt that’s been haunting her since the day he was gunned down.<br/><br/>Ride with Margaret Thomas as she reveals this frightening tale from her point of view. A strong woman and the bloody West meet in this unforgettable epic adventure in the tradition of <i>True Grit</i>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Del Howison
      </h2>
      
      <p class="authorDescription body article">Del Howison is a Bram Stoker award-winning editor and author. He has been nominated for a half-dozen awards including the Black Quill and the Shirley Jackson Award. His work has appeared in dozens of books. In 1994, along with his wife, Susan, he opened the world-famous horror store Dark Delicacies in Burbank, California, which has been inducted to the Rondo Hatton Hall of Fame. He has also served on the board of trustees for the Horror Writers Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b82553c8